import type {
  AboutPageDefaultContentTemplateDynamicZone,
  AboutPageQuery,
  AboutPageQueryVariables,
} from '@edwin-group/cj-graphql/generated/graphql';
import DefaultContentTemplatePage from '../default-content-template';

import { useQueryCacheAndNetwork } from '@/hooks/useQueryCacheAndNetwork';
import { QUERY_ABOUT_PAGE } from '@edwin-group/cj-graphql';

const AboutPage = () => {
  const { data, loading } = useQueryCacheAndNetwork<AboutPageQuery, AboutPageQueryVariables>(QUERY_ABOUT_PAGE);

  if (loading) {
    return null;
  }
  const page = data?.aboutPage;
  const template = page?.DefaultContentTemplate || null;

  return (
    <>
      <DefaultContentTemplatePage
        template={template as Array<AboutPageDefaultContentTemplateDynamicZone>}
        title={page?.pageTitle || 'Back to the Homepage'}
      />
    </>
  );
};

export default AboutPage;
